export default "<app-header></app-header>\n\n<h1>Make a Video call here</h1>\n";